import styles from './CardCountIcon.module.scss'

type Props = {
  count: number
}

const CardCountIcon = ({ count }: Props) => (
  <div className={styles.container}>
    {Array.from({ length: count }, (_, i) => (
      <div className={styles.card} key={i} style={{ marginLeft: '-.8rem', marginTop: `.${2 * i}rem` }} />
    ))}
  </div>
)

export default CardCountIcon
